import { useState, useCallback } from 'react';

import { getUserIpAddress } from '@/util/getUserIpAddress';

export interface ConsentMetadata {
  ipAddress: string | null;
  userAgent: string;
}

export function useConsentStep() {
  const [hasConsentedToTos, setHasConsentedToTos] = useState(false);
  const [hasConsentedToSms, setHasConsentedToSms] = useState(false);
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);

  const handleScrolledToBottom = useCallback(() => {
    setHasScrolledToBottom(true);
  }, []);

  const resetConsent = useCallback(() => {
    setHasConsentedToTos(false);
    setHasConsentedToSms(false);
    setHasScrolledToBottom(false);
  }, []);

  return {
    hasConsentedToTos,
    setHasConsentedToTos,
    hasConsentedToSms,
    setHasConsentedToSms,
    hasScrolledToBottom,
    handleScrolledToBottom,
    resetConsent,
  };
}
